import React from "react";
import { MenuItem } from "../components/Otros/MenuItem";
import { Permisos } from "../utils/Global";

const Menu = () => {
  return (
    <div className="aside-menu flex-column-fluid">
      <div
        className="hover-scroll-overlay-y my-5 my-lg-5"
        id="kt_aside_menu_wrapper"
        data-kt-scroll="true"
        data-kt-scroll-activate="{default: false, lg: true}"
        data-kt-scroll-height="auto"
        data-kt-scroll-dependencies="#kt_aside_logo, #kt_aside_footer"
        data-kt-scroll-wrappers="#kt_aside_menu"
        data-kt-scroll-offset="0"
      >
        <div
          className="menu menu-column menu-title-gray-800 menu-state-title-primary menu-state-icon-primary menu-state-bullet-primary menu-arrow-gray-500"
          id="#kt_aside_menu"
          data-kt-menu="true"
          data-kt-menu-expand="false"
        >
          <MenuItem icon="ki-duotone ki-home fs-2" to="/home">
            Inicio
          </MenuItem>

          {Permisos(["ROL_PRECALIFICADOR"]) ? (
            
            <div className="menu-item">
              <div className="menu-content pt-8 pb-2">
                <span className="menu-section text-muted text-uppercase fs-8 ls-1">
                  PRECALIFICADORES
                </span>
              </div>
            </div>
          ) : (
            <></>
          )}
          
          
          {Permisos(["ROL_PRECALIFICADOR"]) ? (
            
            <MenuItem icon="ki-solid ki-watch fs-2" to="/precalificar">
              Precalificaciones Pendientes
            </MenuItem>
          ) : (
            <></>
          )}

          {Permisos(["ROL_PRECALIFICADOR"]) ? (
            
            <MenuItem icon="fas fa-history" to="/historialPrecalificaciones">
              Historial de Precalificaciones
            </MenuItem>
          ) : (
            <></>
          )}

          <div className="menu-item">
            <div className="menu-content pt-8 pb-2">
              <span className="menu-section text-muted text-uppercase fs-8 ls-1">
                MIS CALIFICACIONES
              </span>
            </div>
          </div>
          
          <MenuItem icon="ki-solid ki-watch fs-2" to="/misEvaluaciones">
            Mis Evaluaciones Pendientes
          </MenuItem>
          <MenuItem icon="fas fa-search" to="/misPrecalificaciones">
            Ver Historial de Procesos
          </MenuItem>

          {Permisos(["ROL_ADMIN"]) ? (
            <>
              <div className="menu-item">
                <div className="menu-content pt-8 pb-2">
                  <span className="menu-section text-muted text-uppercase fs-8 ls-1">
                    GERENCIA DE PERSONAS
                  </span>
                </div>
              </div>
              <MenuItem icon="fas fa-plus-circle" to="/crearProceso">
                Crear proceso
              </MenuItem>
              <MenuItem icon="fas fa-search" to="/buscarProceso">
                Buscar proceso
              </MenuItem>
              <MenuItem icon="fas fa-search" to="/buscarCalificacion">
                Buscar calificación
              </MenuItem>
            </>            
          ) :<></>}

         

          

          {Permisos(["ROL_ADMIN_MUN"]) ? (
            <div className="menu-item">
              <div className="menu-content pt-8 pb-2">
                <span className="menu-section text-muted text-uppercase fs-8 ls-1">
                  Administración municipal
                </span>
              </div>
            </div>
          ) : (
            <></>
          )}
          {Permisos(["ROL_ADMIN_MUN"]) ? (
            <MenuItem icon="ki-solid ki-watch fs-2" to="/administracionMunicipal">
              Autorizaciones pendientes
            </MenuItem>
          ) : (
            <></>
          )}

          {Permisos([
            "ROL_JC_PRESIDENTE",
            "ROL_JC_SECRETARIO",
            "ROL_JC_REPRESENTANTE",
            "ROL_JC_MIEMBRO_UNO",
            "ROL_JC_MIEMBRO_DOS",
            "ROL_JC_PDTE_ASOC",
            "ROL_ADMIN"
          ]) ? (
            <>
              <div className="menu-item">
                <div className="menu-content pt-8 pb-2">
                  <span className="menu-section text-muted text-uppercase fs-8 ls-1">
                    Procesos de Calificación
                  </span>
                </div>
              </div>
              
            </>
          ) : (
            <></>
          )}
         
          {Permisos([
            "ROL_JC_PRESIDENTE",
            "ROL_JC_SECRETARIO",
            "ROL_JC_REPRESENTANTE",
            "ROL_JC_MIEMBRO_UNO",
            "ROL_JC_MIEMBRO_DOS",
            "ROL_JC_PDTE_ASOC",
            "ROL_ADMIN",
          ]) ? (
            <>
              <MenuItem icon="fas fa-search" to="/calificacionesPendientes">
                Proceso de Ratificación
              </MenuItem>
              <MenuItem icon="fas fa-bell" to="/notificaciones">
                Proceso de Notificación
              </MenuItem>
              { /*}
              <MenuItem icon="fas fa-check" to="/listarRatificadas">
                Proceso de Conformidad
              </MenuItem>
              {*/}
              <MenuItem icon="fas fa-check" to="/procesoConformidad">
                Proceso de Conformidad
              </MenuItem>
              <MenuItem icon="fas fa-bell" to="/listarRatificadas">
                Gestión proceso activo
              </MenuItem>
            </>
          ) : (
            <></>
          )}

          {Permisos(["ROL_JC_SECRETARIO"]) ? (
            <MenuItem icon="ki-solid ki-watch fs-2" to="/apelacionesPendientes">
              Apelaciones pendientes de firma
            </MenuItem>
          ) : (
            <></>
          )}

          <div className="menu-item">
            <div className="menu-content">
              <div className="separator mx-1 my-4"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Menu;
